module.exports = __webpack_public_path__ + "img/sell-title.f4d57285.png";